export default "__VITE_ASSET__YqeRBjly__"